module.exports = __webpack_public_path__ + "static/img/avatar-6.11d7dc68.jpg";